/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/copy'
export default icon
